module.exports = __webpack_public_path__ + "static/photo-f6136700eeddd41ff4f37852ee445be4.jpg";